import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const VendorUsersContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',

  'div.inputEmailRow': {
    display: 'flex'
  },

  'div.userDetailRow': {
    display: 'flex',
    
    '.row.disabled': {
      color: 'red',
      textDecoration: 'line-through'
    }
  },
})